import { useState, useEffect } from "react";
import { toast } from "react-toastify";

import CustomModalForm from "@/components/desktop/form/modal/CustomModalForm/CustomModalForm";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";
import { useEstateOutData, useEstateOutAll } from "@/hooks/maintainers/estates/useEstates";

const EstateOutModal = ({ open, onClose, estateId }) => {
	const { data: params, isLoading: _ } = useEstateOutData(open && !!estateId);
	const { mutate: outAll, isLoading: isOuting } = useEstateOutAll();

	const [data, setData] = useState({
		user_id: "",
		operator_id: "",
		balance_id: "",
		business_center_id: "",
	});

	useEffect(() => {
		if (open) {
			setData({
				user_id: "",
				operator_id: "",
				balance_id: "",
				business_center_id: "",
			});
		}
	}, [open]);

	const handleOut = () => {
		if (!data.user_id || !data.operator_id || !data.balance_id || !data.business_center_id) {
			toast.error("Todos los campos son requeridos");
			return;
		}

		outAll(
			{ ...data, estate_id: estateId },
			{
				onSuccess: () => {
					toast.success("Todos los productos han quedado fuera de bodega");
					onClose();
				},
				onError: () => {
					toast.error("Error al sacar productos");
				},
			},
		);
	};

	return (
		<CustomModalForm
			open={open}
			onClose={onClose}
			title="Sacar productos"
			size="md"
			isLoading={isOuting}
			processingMessage="Procesando salida de productos..."
			onSubmit={handleOut}
			textForm="Sacar Productos"
			closeOnBackdrop={false}
			closeOnEsc={false}
		>
			<CustomInputSelect
				label="Usuario"
				value={data.user_id}
				options={params?.data.users || []}
				onChange={(v) => setData({ ...data, user_id: v })}
				placeholder="Seleccione"
			/>
			<CustomInputSelect
				label="Operador"
				value={data.operator_id}
				options={params?.data.operators || []}
				onChange={(v) => setData({ ...data, operator_id: v })}
				placeholder="Seleccione"
			/>
			<CustomInputSelect
				label="Balanza"
				value={data.balance_id}
				options={params?.data.balances || []}
				onChange={(v) => setData({ ...data, balance_id: v })}
				placeholder="Seleccione"
			/>
			<CustomInputSelect
				label="Centro de Costo"
				value={data.business_center_id}
				options={params?.data.business_center || []}
				onChange={(v) => setData({ ...data, business_center_id: v })}
				placeholder="Seleccione"
			/>
		</CustomModalForm>
	);
};

export default EstateOutModal;
